import React, { useEffect, useState } from "react";
import { Card, Table, Button, Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const FabricReceiveReport = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fabricList, setFabricList] = useState([]);

   const [district, setDistricts] = useState([]);
   const [isSearched, setIsSearched] = useState(false);
  const [municipalityList, setMunicipalities] = useState([]);
const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

   const [filters, setFilters] = useState({
      municipality_id: "",
      district_id: "",
      fabric_master_id: ""
    });

     const navigate = useNavigate();

        const getAuthHeader = () => ({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


   const handleExportExcel = () => {
  if (!reports.length) {
    Swal.fire("No Data", "Nothing to export", "warning");
    return;
  }

  // Get Municipality Name (from first record)
  const municipalityName =
    reports[0]?.municipality_name?.replace(/\s+/g, "_") || "All_Municipalities";

  // Format today's date (DD-MM-YYYY)
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;

  // Format Excel Data
  const formattedData = reports.map((r, index) => ({
    "SL No": index + 1,
    "Date": formatDate(r.custom_date) || "-",
    "Challan Number": r.challan_number || "-",
    "Item": r.fabric_name || "-",
    "Quantity": `${formatQty(r.quantity_in, r.fabric_unit_short_name)} (${r.fabric_unit_short_name || ""})`,
    "Vendor": r.vendor || "-"
  }));

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Fabric Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  // Final File Name
  const fileName = `Fabric_Receive_Report_${municipalityName}_${formattedDate}.xlsx`;

  saveAs(data, fileName);
};

    const loadDistricts = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/districtMasterList`,
        {}, getAuthHeader());
      setDistricts(res.data?.data || []);

    } catch (err) {
      console.error("District load error:", err);

      if (err.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
        localStorage.clear();
        navigate("/suda/login");
      } else if (err.response?.status === 422) {
        Swal.fire(
          "Validation Failed",
          err.response.data?.message || "Invalid request",
          "warning"
        );
      } else {
        Swal.fire("Alert!", "Failed to load districts", "error");
      }
    }
  };

  const loadMunicipalities = async (districtId = filters.district_id) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/municipalityList`,
      {
        district_id: districtId || "",
      },
      getAuthHeader()
    );

    setMunicipalities(res.data?.data || []);

  } catch (err) {

    if (err.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      localStorage.clear();
      navigate("/suda/login");
    } else if (err.response?.status === 422) {
      Swal.fire(
        "Validation Failed",
        err.response.data?.message || "Invalid request",
        "warning"
      );
    } else {
      Swal.fire("Alert!", "Failed to load municipalities", "error");
    }
  }
};

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`; // DD-MM-YYYY
};

const formatQty  = (qty,unit) =>{
    if(unit === "pcs"){
        return Number(qty);
    }
    return qty;
}

const muniName =
  filters.municipality_id
    ? municipalityList.find(
        (m) => String(m.user_id) === String(filters.municipality_id)
      )?.name || "Municipality"
    : "All Municipalities";

const fetchFabricList = async () => {
  try {
    const res = await axios.post(`${BASE_URL}/fabricList`,{}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (res.data?.status) {
      setFabricList(res.data.data.fabricList || []);
    } else {
      setFabricList([]);
    }
  } catch (err) {
    console.log("Fabric API Error:", err);

     if (err.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      localStorage.clear();
      navigate("/suda/login");
    }
  }
};

const loadFabricReceiveReport = async (customFilters = filters) =>
    {
      try {
      setLoading(true);
  const token = localStorage.getItem("token");

      const res = await axios.post(
  `${BASE_URL}/municipalityWisefabricReceiveReport`,
  customFilters,
  {
    headers: { Authorization: `Bearer ${token}` },
  }
);
             setReports(res.data.data || []);


    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
};



  useEffect(() => {
    loadDistricts();
    // loadFabricReceiveReport();
    fetchFabricList();

  }, []);



  const theadStyle = {
    padding: "8px",
    fontWeight: "600",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
    backgroundColor: "#edf7fe",
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 1600 }}>

      {/* ================= FILTER CARD ================= */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
         className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold">
            ULB Wise Fabric Receive Report
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row  className="align-items-center">

            {/* District */}
            <Col md={3}>
                                <Form.Group className="mb-3">
                                  <Form.Label className="fw-semibold text-dark">District  <span className="text-danger">*</span></Form.Label>
                                  <Form.Select
                                    value={filters.district_id}
                                    onChange={(e) => {
              const districtId = e.target.value;

              setFilters({
                ...filters,
                district_id: districtId,
                municipality_id: "",
              });

              loadMunicipalities(districtId);
            }}


                                    style={{
                                      borderRadius: "10px",
                                      border: "2px solid #1565C1",
                                    }}
                                  >
                                    <option value="">Select District</option>
                                    {district.map((d) => (
                                      <option value={d.id} key={d.id}>
                                        {d.name || d.district_name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Form.Group>
                              </Col>

            {/* Municipality */}
            <Col md={3}>
                                      <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                          Municipality <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                          value={filters.municipality_id}
                                          style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                                          onChange={(e) =>
                                      setFilters({ ...filters, municipality_id: e.target.value })
                                    }
                                        >
                                          <option value="">Select Municipalities</option>
                                          {municipalityList.map((m) => (
                                            <option key={m.user_id} value={m.user_id}>
                                              {m.name}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col>

                                     <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-black">Fabric (Optional)</Form.Label>
    <Form.Select
      value={filters.fabric_master_id}
      onChange={(e) =>
        setFilters({ ...filters, fabric_master_id: e.target.value })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">Select Fabric</option>

      {fabricList.map((item) => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

            {/* Buttons */}
            <Col md={4} className="d-flex gap-3 mt-3">
                                {/* SEARCH */}
                                <Button
                                  className="w-50 fw-semibold text-white"
                                  style={{
                                    background: "#1565C1",
                                    border: "none",
                                    borderRadius: "10px",
                                    transition: "0.3s",
                                  }}
                                  onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                                  onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
            onClick={() => {

                if (!filters.district_id) {
    Swal.fire("Alert", "Please select District first", "warning");
    return;
  }

  if (!filters.municipality_id) {
    Swal.fire("Alert", "Please select Municipality", "warning");
    return;
  }
loadFabricReceiveReport();
setIsSearched(true);
              }}
                                >
                                  <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                                </Button>

                                {/* RESET */}
                                <Button
                    className="w-50 fw-semibold text-white"
                    style={{
                      background: "#E53935",
                      border: "none",
                      borderRadius: "10px",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                    onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                    onClick={() => {
                        const resetFilters = { municipality_id: "", district_id: "",fabric_master_id: "" };

                        setFilters(resetFilters);
                        setMunicipalities([]);
                        setReports([]);
                        setIsSearched(false);
                        loadFabricReceiveReport(resetFilters);


                    }}
                  >
                    <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                  </Button>
                </Col>
          </Row>
        </Card.Body>
      </Card>


       <Button
            style={{
              background: "#43A047",
              border: "none",
              borderRadius: "8px",
            }}
            className="mb-4"
            onClick={handleExportExcel}
          >
           <i class="fa-solid fa-file-excel"></i> Export to Excel
          </Button>

      {/* ================= TABLE ================= */}

{isSearched && filters.municipality_id && (
  <div className="text-center mb-4">
    <h4 className="fw-bold text-dark mb-1">{muniName}</h4>
    <div className="fs-6 text-success">
      Fabric Receive Report (As on {today})
    </div>
  </div>
)}


      <Card
        className="border-0"
        style={{
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}
      >
        {/* HEADER WITH EXPORT BUTTON */}


        {loading ? (
<div className="loader-wrapper">
    <div className="blue-spinner"></div>

    <div className="loading-line">
      <div className="loading-progress"></div>
    </div>

    <p className="loading-text">              Please Wait... While Gathering Reports</p>
  </div>        ) : (
          <Table bordered hover responsive striped className="mb-0">
            <thead>
              <tr>
                <th style={theadStyle}>SL No</th>
                <th style={theadStyle}>Date</th>
                <th style={theadStyle}>Challan Number</th>
                <th style={theadStyle}>Item</th>
                <th style={theadStyle}>Quantity</th>
                <th style={theadStyle}>Vendor</th>

              </tr>
            </thead>

            <tbody>
  {!isSearched ? (
    <tr>
      <td colSpan="7" className="text-center py-4 text-muted">
        Please select a district and municipality
      </td>
    </tr>
  ) : reports.length === 0 ? (
    <tr>
      <td colSpan="7" className="text-center py-4 text-muted">
        No records found
      </td>
    </tr>
  ) : (
    reports.map((r, index) => (
      <tr key={index}>
        <td className="text-center">{index + 1}</td>
        <td className="text-center">{formatDate(r.custom_date) || "-"}</td>
        <td className="text-center">{r.challan_number || "-"}</td>
        <td className="text-center">{r.fabric_name || "-"}</td>
        <td className="text-center">
          {formatQty(r.quantity_in, r.fabric_unit_short_name)} ({r.fabric_unit_short_name})
        </td>
        <td className="text-center">{r.vendor || "-"}</td>
      </tr>
    ))
  )}
</tbody>
          </Table>
        )}
      </Card>
    </div>
  );
};

export default FabricReceiveReport;
